import HeaderSection from '../components/HeaderSection/HeaderSection'
import Line from '../components/Line/Line'


const reckewegOptions = [
  { id: 'goteros', name: 'Goteros',  firstProductId: 31  },
  { id: 'jarabes', name: 'Jarabes, aceites, y soluciones tópicas', firstProductId: 130 },
  { id: 'capsulas', name: 'Cápsulas', firstProductId: 137 },
  { id: 'solucion-esteril', name: 'Solución estéril con nebulizador nasal', firstProductId: 138 },
  { id: 'procaina-kholer', name: 'Procaína Kholer 2%', firstProductId: 135 },
  { id: 'inyectables', name: 'Inyectables', firstProductId: 1 },
  { id: 'sales', name: 'Sales de Schüssler', firstProductId: 118},
]

const tegorOptions = [
  { id: 'depuracion', name: 'Depuración', firstProductId: 140 },
  { id: 'control-peso', name: 'Control de peso', firstProductId: 166 },
  { id: 'celulitis-piernas', name: 'Celulitis y piernas', firstProductId: 184 },
  { id: 'transito-digestion', name: 'Tránsito y digestión', firstProductId: 201 },
  { id: 'para-mujer', name: 'Para la mujer', firstProductId: 226 },
  { id: 'para-hombres', name: 'Para hombres', firstProductId: 241 }
]

const helixorOptions = [
  { id: 'helixor-a', name: 'Helixor A', firstProductId: 266 },
  { id: 'helixor-m', name: 'Helixor M', firstProductId: 267 },
  { id: 'helixor-p', name: 'Helixor P', firstProductId: 268 }
]

const symbioOptions = [
  { id: 'symbioflor-1', name: 'Symbioflor® 1',  firstProductId: 262 },
  { id: 'symbioflor-2', name: 'Symbioflor® 2', firstProductId: 263 },
  { id: 'symbiolact-comp', name: 'SymbioLact® COMP', firstProductId: 264 },
  { id: 'symbiointest', name: 'SymbioINTEST®', firstProductId: 265 }
]

const regenhialOptions = [
  { id: 'regenhial', name: 'Regenhial', firstProductId: 269 },
  { id: 'regenhial-intim', name: 'Regenhial INTIM', firstProductId: 273 },
  { id: 'regenhial-concentrates', name: 'Regenhial Concentrates', firstProductId: 271 },
  { id: 'regenhial-oral', name: 'Regenhial Oral', firstProductId: 275 }
]

const Lines = () => {
  return (
    <div>
      <HeaderSection title={'Líneas Eupha'} subtitle={'Nuestras Líneas'} />
      <Line brand={'dr-reckeweg'} title={'Homeopatía'} options={reckewegOptions}/>
      <Line brand={'tegor'} title={'Fitoterapia'} options={tegorOptions} />
      <Line brand={'helixor'} title={'Terapia Oncológica'} options={helixorOptions} />
      <Line brand={'symbio'} title={'Terapia Microbiológica'} options={symbioOptions} />
      <Line brand={'regenhial'} title={'Dermocosmética'} options={regenhialOptions} />
    </div>
  );
}

export default Lines;
